// src/pages/ZoomCallback.jsx
import React, { useEffect, useState } from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ZoomCallback = () => {
  const query = useQuery();
  const status = query.get('status');
  const message = query.get('message');
  const [statusText, setStatusText] = useState('Processing Zoom connection...');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useUser();

  useEffect(() => {
    const run = async () => {
      if (status === 'success') {
        setStatusText('✓ Zoom connected successfully! Redirecting to settings...');
        setIsError(false);
        try {
          await refreshUser();
          setTimeout(() => navigate('/settings'), 1500);
        } catch (err) {
          setStatusText('Zoom connected, but unable to refresh your account. Please reload the page.');
          setIsError(true);
        }
      } else {
        setIsError(true);
        let errorMsg = 'Unable to connect to Zoom.';
        
        switch(message) {
          case 'missing_code_or_state':
            errorMsg = 'Connection cancelled or invalid. Please try again.';
            break;
          case 'invalid_state':
            errorMsg = 'Security check failed. Please try connecting again.';
            break;
          case 'token_exchange_failed':
            errorMsg = 'Failed to authorize with Zoom. Please check your Zoom account and try again.';
            break;
          case 'user_not_found':
            errorMsg = 'Your account was not found. Please sign in and try again.';
            break;
          default:
            errorMsg = message ? `Error: ${message}` : 'An unexpected error occurred.';
        }
        
        setStatusText(`✗ ${errorMsg}`);
        setTimeout(() => navigate('/settings'), 4000);
      }
    };
    run();
  }, [status, message, refreshUser, navigate]);

  return (
    <div>
      <Header />
      <main className="max-w-3xl mx-auto p-8 min-h-screen">
        <div className={`text-center p-8 rounded-lg ${
          isError 
            ? 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800' 
            : 'bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800'
        }`}>
          <h1 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Zoom Integration</h1>
          <p className={`text-lg ${
            isError 
              ? 'text-red-700 dark:text-red-300' 
              : 'text-blue-700 dark:text-blue-300'
          }`}>
            {statusText}
          </p>
          {isError && (
            <button
              onClick={() => navigate('/settings')}
              className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Go to Settings
            </button>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ZoomCallback;